<template>
  <div :class="['header', computeClasses]" v-if="showHeader">
    <div class="header-logo-wrapper">
      <img
        v-if="isMerchantLogoSet"
        :src="merchantLogoUrl"
        alt="logo"
        class="logo"
      />
    </div>
    <template v-if="isShowInfo">
      <div class="info">
        <div class="payment">
          <div class="full-label">Payment Total</div>
          <div class="mobile-label">Total</div>
          <div class="amount">{{ currency }}{{ amount }}</div>
        </div>
      </div>
      <div
        v-if="isOpenBankingApplicable"
        class="cancel-btn"
        @click="showCancelTransaction"
      >
        <div class="rect one"></div>
        <div class="rect two"></div>
      </div>
    </template>

    <portal to="modal">
      <transition name="modal-fade">
        <cancel-transaction-modal
          v-if="isShowCancelTransaction"
          :is-show-retry="isShowRetry"
          :is-cancelling="isCancelling"
          @cancel-transaction="cancelTransaction"
          @close="hideCancelTransaction"
        />
      </transition>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CancelTransactionModal from '../components/CancelTransactionModal'
import { isOpenBankingAcquirer, isStringSet } from '@/utils'

export default {
  name: 'Header',
  components: {
    CancelTransactionModal,
  },
  computed: {
    ...mapState('merchantSettings', ['merchantLogoUrl']),
    ...mapState('transaction', ['transaction', 'showCancel', 'showBodyOnly']),
    amount() {
      return this.transaction && this.transaction.amount
    },
    showHeader() {
      return !this.showBodyOnly
    },
    currency() {
      const currency = this.transaction && this.transaction.currency
      if (currency && currency.toLowerCase() === 'zar') {
        return 'R'
      }
      return currency
    },
    isOpenBankingApplicable() {
      if (isOpenBankingAcquirer(this.transaction.acquirerCode)) {
        return this.showCancel
      }

      return true
    },
    isMerchantLogoSet() {
      return this.merchantLogoUrl && isStringSet(this.merchantLogoUrl)
    },
    computeClasses() {
      return {
        'border-bottom': this.isMerchantLogoSet && !this.showBodyOnly,
      }
    },
  },
  props: {
    isShowInfo: {
      type: Boolean,
      default: true,
    },
    isShowRetry: {
      type: Boolean,
      default: true,
    },
    isCancelling: {
      type: Boolean,
      default: false,
    },
    closeCancelTransactionModal: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      isShowCancelTransaction: false,
    }
  },

  watch: {
    closeCancelTransactionModal() {
      this.hideCancelTransaction()
    },
  },

  methods: {
    showCancelTransaction() {
      this.isShowCancelTransaction = true
      this.$emit('show-cancel-modal')
    },
    hideCancelTransaction() {
      this.isShowCancelTransaction = false
      this.$emit('hide-cancel-modal')
    },
    cancelTransaction() {
      this.$emit('cancel-transaction')
    },
  },
}
</script>

<style scoped lang="scss">
.header {
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media screen and (max-width: $mobile-resolution) {
    padding: 24px 44px 24px 24px;
  }

  .logo {
    width: 100%;
  }

  .header-logo-wrapper {
    display: flex;
    max-height: 75px;
    max-width: 65%;

    @media screen and (max-width: $mobile-resolution) {
      margin-right: 32px;
    }
  }

  .info {
    display: flex;
    align-items: center;

    @media screen and (max-width: $mobile-resolution) {
      flex-direction: row;
      align-items: end;
    }
  }

  .payment {
    margin-right: 24px;

    @media screen and (max-width: $mobile-resolution) {
      display: flex;
      justify-content: center;
      flex-basis: auto;
      height: 50px;
      margin-right: 0;
      flex-direction: column;
    }

    .full-label {
      font-size: 14px;

      @media screen and (max-width: $mobile-resolution) {
        display: none;
      }
    }

    .mobile-label {
      font-size: 14px;
      margin-bottom: 6px;
      color: #0a0908;

      @media screen and (min-width: $mobile-resolution) {
        display: none;
      }
    }

    .amount {
      font-size: 24px;
      color: #000;

      @media screen and (max-width: $mobile-resolution) {
        font-size: 20px;
        line-height: 24px;
        font-weight: 700;
      }
    }
  }

  .full-separator {
    background: #d8d8d8;
    width: 1px;
    height: 48px;

    @media screen and (max-width: $mobile-resolution) {
      margin: 0 10px;
    }
  }

  .merchant-logo-wrapper {
    margin: 0 10px 0 24px;
    max-height: 48px;

    @media screen and (max-width: $mobile-resolution) {
      margin: auto;
      max-width: 117px;
      max-height: 48px;
      flex: 1;
    }
  }

  .website {
    max-width: 100%;
    max-height: 48px;
  }

  .cancel-btn {
    cursor: pointer;
    position: absolute;
    top: -8px;
    right: -8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #fff;
    box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
    display: flex;

    .rect {
      width: 2px;
      position: absolute;
      height: 20px;
      background: #0a0908;
      top: 6px;
      left: 16px;

      &.one {
        transform: rotate(-45deg);
      }

      &.two {
        transform: rotate(45deg);
      }
    }

    @media screen and (max-width: $mobile-resolution) {
      top: 8px;
      right: 8px;
    }
  }
}

.border-bottom {
  border-bottom: 1px solid #d8d8d8;
}
</style>
